<template>
  <v-app light>

    <header-nav></header-nav>

    <v-content class="content-white">
      <v-container fluid grid-list-md>

        <router-view></router-view>

      </v-container>
    </v-content>

    <v-footer :fixed="fixed" app>
      <span class="footer"> {{info.name}} - {{info.version}} </span>
    </v-footer>

  </v-app>
</template>

<script>

import { Global } from '@/Config';
import HeaderNav from './HeaderNav';

// Este component centraliza os componentes de layout do sistema
export default {
  components: {
    HeaderNav,
  },
  name: 'Main',
  data() {
    return {
      fixed: false,
      info: Global.info,
    };
  },
};
</script>

<style scoped>
  .content-white {
    background-color: #FFF;
  }
  .footer {
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Main.vue